export default __webpack_public_path__ + "components/weather-icon/static/nightsnowshowers-7f8cf8d3165827bc080d082746fca603.png";